export function NotFound() {
  return (
    <Centered title="Link not found">
      <p>This application link is invalid or has been removed. Please contact your Fundmerica representative.</p>
    </Centered>
  );
}

export function Centered({ title, children }) {
  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="card max-w-md w-full p-8 text-center">
        <img src="/fundmerica-logo.png" alt="Fundmerica" className="h-8 mx-auto mb-5" />
        <h1 className="text-xl font-semibold mb-3 text-brand-900">{title}</h1>
        <div className="text-sm text-slate-600 space-y-2">{children}</div>
      </div>
    </div>
  );
}
